import { render, staticRenderFns } from "./NewPhysicalShareholder.vue?vue&type=template&id=35fa9078"
import script from "./NewPhysicalShareholder.vue?vue&type=script&lang=js"
export * from "./NewPhysicalShareholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports